export default "/Frontend/dist/fallback-required.1ff4dac13f3988658b39d0b35c6ebb5c.svg";